import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * Wrap routes that require an active subscription (or trial).
 * If the user is logged in but has no access, redirect to /pricing.
 */
export default function SubscriptionGate({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] grid place-items-center text-zinc-500" data-testid="subscription-checking">
        <span className="eyebrow">Loading…</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user.has_access === false) return <Navigate to="/pricing" replace />;
  return children;
}
